import {Component,ContentChildren,QueryList,AfterContentInit, Input, Output, EventEmitter} from '@angular/core';
import {TabComponent} from './tab.component';

@Component({
  selector: 'echexpayment-tabs',
  styleUrls: ['./tab.component.css'],
  template: `
       <ul class="tab-list nav nav-tabs">
        <li *ngFor="let tab of tabs" [class.active]="selectedTab===tab" (click)="onSelect(tab)">
            <a (click)="handle_Click(tab.tabTitle)">{{tab.tabTitle}}</a>
        </li>
       </ul>
       <ng-content></ng-content>
    `
})
export class TabsComponent implements AfterContentInit {
    @Output() tabClicked: EventEmitter<string> = new EventEmitter<string>();

    handle_Click(tabTitle: string): void {
      this.tabClicked.emit(tabTitle);
    }
    @ContentChildren(TabComponent)
    tabs:QueryList<TabComponent>;
    
    selectedTab:TabComponent;

    ngAfterContentInit() {
        this.select(this.tabs.first);
    }

    onSelect(tab) {
        this.select(tab);
    }

    select(tab) {
        this.tabs.forEach((item)=>{
            item.show = false;
        });

        this.selectedTab = tab;
        this.selectedTab.show = true;
    }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/tab/tabs.component.ts